import * as t from 'io-ts';

export const ApiResponseCodec = t.type({
  result: t.string,
});

export type ApiResponseF = t.TypeOf<typeof ApiResponseCodec>;

export type ApiResponse = t.OutputOf<typeof ApiResponseCodec>;
